// extracted by mini-css-extract-plugin
export var orderDetails = "_ur-2";
export var orderImage = "_ur-1";
export var orderMeta = "_ur-3";
export var orderSummary = "_ur-0";
export var rightArrow = "_ur-4";